/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */


import { MDLocaleBase } from '../../manja/locale-base.js';


const MDLocale_en_GB = function(window) {

	const decimal_point_char = '.';
	const duration_units = [
		[ '1 year',  ' years',  31536000 ],
		[ '1 month', ' months',  2592000 ],
		[ '1 week',  ' weeks',    604800 ],
		[ '1 day',   ' days',      86400 ],
		[ '1 hour',  ' hours',      3600 ],
		[ '1 min',   ' mins',         60 ],
		[ '1 sec',   ' sec',           1 ],
	];

	const m_monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];


	function fmt_number_input( n ) {
		return n.toString();
	}
	function xtr_number_input( n ) {
		return n.toString().replace( /,/g, '' );
	}

	function fmt_datetime( d ) {
		var sd = fmt_date(d),
			st = fmt_time(d);
		if( st==='' || st==='00:00' ) return sd;
		return sd + ', ' + st;
	}
	function fmt_datetime_detailed( d ) {
		var sd = fmt_date(d),
			st = fmt_time_detailed(d);
		return st==='' ? sd : (sd+', '+st);
	}

	function fmt_date( d ) {
		if( d===null || d.length===0 ) return '';
		return d.substr(8,2) + '/' + d.substr(5,2) + '/' + d.substr(0,4);
	}
	function fmt_date_ym( d ) {
		if( d===null || d.length===0 ) return '';
		return m_monthNames[parseInt(d.substr(5,2),10)-1] + ' ' + d.substr(0,4);
	}

	function fmt_time( d ) {
		if( d===null || d.length===0 ) return '';
		var offs = d.length >= 10 ? 11 : 0, // datetime or time-only
			s = d.substr(offs,2) + ':' + d.substr(offs+3,2),
			sec = d.substr(offs+6,2)
			;
		if( sec === '' || sec === '00' ) {
			if( s === ':' ) return '';
			return s;
		}
		return s + ':' + sec;
	}
	function fmt_time_detailed( d ) {
		if( d.length < 19 ) return '';
		return d.substr(11,2) + ':' + d.substr(11+3,2) + ':' + d.substr(11+6,2);
	}

	function xtr_datetime( sd, st ) {
		var d = xtr_date(sd);
		if( d !== '' ) {
			var t = xtr_time(st);
			if( t === '' ) t = '00:00:00'; // set to midnight
			d += ' ' + t;
		}
		return d;
	}
	function xtr_date( s ) {
		if( !s.match(/^\d\d\/\d\d\/\d\d\d\d$/) ) return '';
		return s.substr(6,4) + '-' + s.substr(3,2) + '-' + s.substr(0,2);
	}
	function xtr_time( s ) {
		if( s.match(/^\d\d:\d\d:\d\d$/) ) return s;
		else if( s.match(/^\d\d:\d\d$/) ) return s+':00';
		else if( s.match(/^\d\d$/) ) return s+':00:00';
		return '';
	}

	var localized_string_compare = function( a, b ) {
		return a.localeCompare(b,'en-GB',{ignorePunctuation:true});
	};

	try {
		'foo'.localeCompare('bar','en-GB',{ignorePunctuation:true});
	} catch( err ) {
		localized_string_compare = function( a, b ) {
			return a.localeCompare(b);
		};
	}


	return Object.assign( {}, MDLocaleBase, {

		fmt_number_input,
		xtr_number_input,
		fmt_datetime,
		fmt_datetime_detailed,
		fmt_date,
		fmt_date_ym,
		fmt_time,
		fmt_time_detailed,
		xtr_datetime,
		xtr_date,
		xtr_time,
		localized_string_compare,

		decimal_point_char,
		duration_units,

		get_locale: function() {
			return 'en_GB';
		},

		initWithJQuery: function( $ ) {
			/* English/UK initialisation for the jQuery UI date picker plugin. */
			if( $ && $.datepicker ) {
				/* Written by Stuart. */
				$.datepicker.regional['en-GB'] = {
					closeText: 'Done',
					prevText: 'Prev',
					nextText: 'Next',
					currentText: 'Today',
					monthNames: m_monthNames,
					monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
					dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
					weekHeader: 'Wk',
					dateFormat: 'dd/mm/yy',
					firstDay: 1,
					isRTL: false,
					showMonthAfterYear: false,
					yearSuffix: ''};
				$.datepicker.setDefaults($.datepicker.regional['en-GB']);
			}
			// select2 i18n
			if( $ && $.fn.select2 ) {
				$.fn.select2.defaults.set('language',{
					errorLoading:function() {
						return "The results could not be loaded.";
					},
					inputTooLong:function(e) {
						var t=e.input.length-e.maximum,n="Please delete "+t+" character"; return t!=1&&(n+="s"),n;
					},
					inputTooShort:function(e) {
						var t=e.minimum-e.input.length,n="Please enter "+t+" or more characters"; return n;
					},
					loadingMore:function() {
						return "Loading more results…";
					},
					maximumSelected:function(e) {
						var t="You can only select "+e.maximum+" item"; return e.maximum!=1&&(t+="s"),t;
					},
					noResults:function() {
						return "No results found";
					},
					searching:function(e) {
						window._mj_cur_select2_query=e; return "Searching…";
					},
				});
			}
		}
	} );
}(window); // namespace MDLocale_en_GB

MDLocaleBase.init_with_impl(MDLocale_en_GB);

// eslint-disable-next-line import/no-unused-modules
export default MDLocale_en_GB;
